import { mapGetters } from 'vuex';
import EcsSideBarPendingInteractionMixin from '@/mixins/ecs-side-bar-pending-interaction-mixin/EcsSideBarPendingInteractionMixin';

export default {
  data() {
    return {
      searchString: '',
      availableTotalHeight: 0
    };
  },

  mixins: [EcsSideBarPendingInteractionMixin],

  computed: {
    ...mapGetters('SETTINGS', ['isOfflineModeEnabled']),

    pendingInteractionsContainerHeight() {
      return this.displayPendingInteraction ? this.getPendingInteractions.length * 72 + 53 : 0;
    },

    activeInteractionsContainerHeight() {
      return this.filteredItems.activeInteractions.length ? this.filteredItems.activeInteractions.length * 72 + 53 : 0;
    },

    historicInteractionsContainerHeight() {
      return (
        this.availableTotalHeight - this.pendingInteractionsContainerHeight - this.activeInteractionsContainerHeight
      );
    }
  },

  mounted() {
    // Initialize responsive height value
    const appHeaderHeight = this.isOfflineModeEnabled ? 94 : 64;
    this.availableTotalHeight = window.innerHeight - appHeaderHeight - 2 - 68;
    window.addEventListener('resize', this.onResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize() {
      const appHeaderHeight = this.isOfflineModeEnabled ? 94 : 64;
      this.availableTotalHeight = window.innerHeight - appHeaderHeight - 2 - 68;
    },

    filterItems(items) {
      return (items || []).filter(item => {
        const searchableAttributes = `${item.crm.customerFullName || ''} ${item.routing.destination || ''}
          ${item.routing.origin || ''} ${item.receptor.name || ''} ${this.getAdditionalSerchableAttributes(
          item
        )}`.trim();
        return new RegExp(this.searchString, 'i').test(searchableAttributes);
      });
    },

    handleSearch(searchString) {
      this.searchString = searchString;
    }
  }
};
